import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const createAppBrand = async (payload: Partial<IAppBrand>) => {
	const url = "/homepage/admin/app-branding/";
	const response = await cmsClient.post<IAppBrand>(url, payload);

	return response.data;
};

const useCreateAppBrand = () => {
	const navigate = useNavigate();

	const onSuccess = () => {
		toast.success(
			<CustomToast
				type="Success"
				message="App rebrand saved to the library."
			/>,
			{ hideProgressBar: true }
		);

		navigate("/vendor-sponsorship/app-branding/brands?published=false");
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(createAppBrand, {
		onError,
		onSuccess,
	});

	return mutation;
};

export default useCreateAppBrand;
